// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PorticoPortalChildModel {
    static getAttributeTypeMap() {
        return PorticoPortalChildModel.attributeTypeMap;
    }
}
PorticoPortalChildModel.discriminator = undefined;
PorticoPortalChildModel.additionalProperties = false;
PorticoPortalChildModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
    {
        "name": "childId",
        "baseName": "childId",
        "type": "string"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
];
//# sourceMappingURL=porticoPortalChildModel.js.map